// First partial-month charge for a coaching program, estimated from the
// program's weekly session count rather than raw calendar days.
//
// Registration only ever captures a program's session *frequency*
// (days_per_week) — the actual weekdays a batch meets aren't decided until
// an Admin assigns one later — so this is necessarily an estimate. A month
// is treated as a flat 4 weeks (2/wk -> 8 sessions, 3/wk -> 12, 5/wk -> 20),
// matching the academy's own pricing convention, rather than the calendar's
// actual day count or the programs.sessions_per_month column (many active
// programs still have it stored as 0 and can't be relied on).
//
// Mirrors services/proration_service.py::estimate_proration — keep both in
// sync if this changes.
export function estimateProration(daysPerWeek, monthlyNet, today = new Date()) {
  const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
  const daysLeft = daysInMonth - today.getDate() + 1; // inclusive of today

  const dpw = daysPerWeek || 0;
  const totalSessions = Math.max(1, Math.round(dpw * 4));
  let remainingSessions = Math.round(dpw * daysLeft / 7);
  remainingSessions = Math.max(0, Math.min(totalSessions, remainingSessions));

  const prorated = monthlyNet > 0
    ? Math.round(monthlyNet * remainingSessions / totalSessions * 100) / 100
    : 0;

  return { daysInMonth, daysLeft, totalSessions, remainingSessions, prorated };
}
